export class Delays {
    constructor(public restTipDelay = NaN,
                public firstTipDelay = NaN,
                public secondTipDelay = NaN,
                public thirdTipDelay = NaN) {
    }
}
